// judgeme-fullrev-layout.js
// Restructures the Judge.me full review modal layout:
// Left: images (pics/vids)
// Right: header, content, product (stacked vertically)

(function () {
  try {
    function debug() {
      if (window && window.console && typeof window.console.log === 'function') {
        window.console.log.apply(window.console, arguments);
      }
    }

    debug('[judgeme-fullrev-layout] script loaded');

    function restructureFullReview(fullRevDiv) {
      if (!fullRevDiv || fullRevDiv.dataset.jfrlProcessed) return;

      try {
        debug('[judgeme-fullrev-layout] processing .jdgm-full-rev', fullRevDiv);

        // Get all child divs we need to move around
        var header = fullRevDiv.querySelector('.jdgm-full-rev__header');
        var content = fullRevDiv.querySelector('.jdgm-full-rev__content');
        var productWrapper = fullRevDiv.querySelector('.jdgm-full-rev__product-wrapper');

        if (!header || !content || !productWrapper) {
          debug('[judgeme-fullrev-layout] missing required elements (header, content, or product-wrapper)');
          fullRevDiv.dataset.jfrlProcessed = '1';
          return;
        }

        // Extract pics and vids from content (they should move to left column)
        var pics = content.querySelector('.jdgm-full-rev__pics');
        var vids = content.querySelector('.jdgm-full-rev__vids');

        // Create left column container for images
        var leftCol = document.createElement('div');
        leftCol.className = 'jdgm-fullrev-layout__left-column';
        leftCol.style.cssText = 'flex: 0 0 40%; flex-basis: 40%; max-width: 480px; min-width: 220px; display: flex; flex-direction: column; gap: 10px; overflow: hidden;';

        // Create right column container for text content
        var rightCol = document.createElement('div');
        rightCol.className = 'jdgm-fullrev-layout__right-column';
        rightCol.style.cssText = 'flex: 1; display: flex; flex-direction: column; gap: 15px;';

        // Move images to left column and make pics a horizontal, snap-scrolling strip
        if (pics) {
          pics.style.cssText = 'width: 100%; display: flex; gap: 10px; overflow-x: auto; -webkit-overflow-scrolling: touch; scroll-snap-type: x mandatory; padding-bottom: 6px;';
          // Ensure each pic/item is sized for the horizontal strip
          for (var i = 0; i < pics.children.length; i++) {
            var child = pics.children[i];
            if (child && child.style) {
              child.style.cssText = 'flex: 0 0 auto; scroll-snap-align: center; display: flex; align-items: center; justify-content: center;';
              var imgs = child.querySelectorAll('img');
              for (var j = 0; j < imgs.length; j++) {
                imgs[j].style.maxWidth = '100%';
                imgs[j].style.height = 'auto';
                imgs[j].style.display = 'block';
              }
            }
          }
          leftCol.appendChild(pics);
          debug('[judgeme-fullrev-layout] moved pics to left column as horizontal scroller');
        }
        if (vids) {
          vids.style.cssText = 'width: 100%;';
          leftCol.appendChild(vids);
          debug('[judgeme-fullrev-layout] moved vids to left column');
        }

        // Clean content div: remove pics/vids if they were there
        if (pics && pics.parentNode === content) {
          content.removeChild(pics);
        }
        if (vids && vids.parentNode === content) {
          content.removeChild(vids);
        }

        // Add header, content, product to right column (in order)
        rightCol.appendChild(header);
        rightCol.appendChild(content);
        rightCol.appendChild(productWrapper);

        // Reorder header children: profile-wrapper first, then rating-and-timestamp-wrapper
        var profileWrapper = header.querySelector('.jdgm-full-rev__profile-wrapper');
        var ratingWrapper = header.querySelector('.jdgm-full-rev__rating_and_timestamp_wrapper');
        if (profileWrapper && ratingWrapper) {
          // Extract timestamp from rating wrapper and move inside profile-wrapper
          var timestamp = ratingWrapper.querySelector('.jdgm-full-rev__timestamp');
          if (timestamp && timestamp.parentNode) {
            // Move timestamp into profile-wrapper
            timestamp.parentNode.removeChild(timestamp);
            profileWrapper.appendChild(timestamp);
            debug('[judgeme-fullrev-layout] moved timestamp inside profile-wrapper');
          }
          // Ensure correct order: profile-wrapper first, then rating wrapper
          if (profileWrapper.parentNode === header) header.removeChild(profileWrapper);
          if (ratingWrapper.parentNode === header) header.removeChild(ratingWrapper);
          header.appendChild(profileWrapper);
          header.appendChild(ratingWrapper);
          debug('[judgeme-fullrev-layout] reordered header: profile-wrapper (with timestamp) first, rating-and-timestamp-wrapper second');
        }

        debug('[judgeme-fullrev-layout] appended header, content, product to right column');

        // Clear and rebuild fullRevDiv with two columns
        while (fullRevDiv.firstChild) {
          fullRevDiv.removeChild(fullRevDiv.firstChild);
        }

        fullRevDiv.style.cssText = 'display: flex; flex-direction: row; gap: 20px; width: 100%; align-items: flex-start;';
        fullRevDiv.appendChild(leftCol);
        fullRevDiv.appendChild(rightCol);

        debug('[judgeme-fullrev-layout] restructured .jdgm-full-rev layout complete');

        fullRevDiv.dataset.jfrlProcessed = '1';
      } catch (err) {
        console.error('[judgeme-fullrev-layout] error restructuring', err);
        fullRevDiv.dataset.jfrlProcessed = '1';
      }
    }

    function scan() {
      var fullRevs = document.querySelectorAll('.jdgm-full-rev');
      if (!fullRevs || fullRevs.length === 0) {
        debug('[judgeme-fullrev-layout] no .jdgm-full-rev found');
        return;
      }
      debug('[judgeme-fullrev-layout] found', fullRevs.length, '.jdgm-full-rev elements');
      fullRevs.forEach(restructureFullReview);
    }

    function attachObservers() {
      var mo = new MutationObserver(function (mutations) {
        var added = mutations.some(function (m) { return m.addedNodes && m.addedNodes.length > 0; });
        if (added) scan();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }

    function run() {
      try {
        scan();
        attachObservers();
        // Delayed scans in case widget loads late
        setTimeout(scan, 500);
        setTimeout(scan, 1500);
        setTimeout(scan, 3000);
      } catch (err) {
        console.error('[judgeme-fullrev-layout] run error', err);
      }
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      run();
    } else {
      document.addEventListener('DOMContentLoaded', run);
      window.addEventListener('load', run);
    }
  } catch (e) {
    console.error('[judgeme-fullrev-layout] top-level error', e);
  }
})();
